import { render, staticRenderFns } from "./NewSettings.vue?vue&type=template&id=a4c65502&scoped=true"
import script from "./NewSettings.vue?vue&type=script&lang=js"
export * from "./NewSettings.vue?vue&type=script&lang=js"
import style0 from "./NewSettings.vue?vue&type=style&index=0&id=a4c65502&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a4c65502",
  null
  
)

export default component.exports